/**
 * @generated SignedSource<<d9f79a7addbd9ea45c64b472c11e51e6>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselThumb_viewInRoomPhoto$data = {
  readonly credits: string | null;
  readonly src: string | null;
  readonly " $fragmentType": "HeroCarouselThumb_viewInRoomPhoto";
};
export type HeroCarouselThumb_viewInRoomPhoto$key = {
  readonly " $data"?: HeroCarouselThumb_viewInRoomPhoto$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselThumb_viewInRoomPhoto">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselThumb_viewInRoomPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};

(node as any).hash = "034e9fbca888118be4471984e45e3967";

export default node;
